import { useState, useEffect, useRef } from 'react';
import { 
X, Zap, ChevronDown
} from 'lucide-react';
import { ToastContainer, toast } from "react-toastify";
import defaultData from "../demoDefaultData.json";
import languageData from "../languages.json"
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";
import { getToken } from "../utils/auth";
import {Step1PlanRightColumn} from "../components-sub/Step1PlanRight"
import { handleUpload } from "../functions/upload_to_MM.jsx";
import "react-toastify/dist/ReactToastify.css";

export function Step1Plan ({ 
    audioData,
    setAudio,
    bannerData,
    setBanner,
    CompanyName,
    setCompanyName,
    language,
    setLanguage,
    setlogoUrl,
    logoUrl,
    logos,
    setLogos,
    marketingGoals,
    setMarketingGoals,
    voice,
    setVoice,
    targetAudience,
    setTargetAudience,
    vibeAndTone,
    setVibeAndTone, 
    marketingGoalsDropdown,
    targetAudienceDropdown,
    vibeAndToneDropdown,
    voicesDropdown,
    brandColors,
    setBrandColors,
    onGenerate, 
    FadeIn, 
    notify }) {
  // State for tags to demonstrate interactivity
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState(CompanyName || '');
  const [isLogoMenuOpen, setIsLogoMenuOpen] = useState(false);
  const logoMenuRef = useRef(null);

// chain_name

    const [DefaultLogo, setDefaultLogo] = useState('');
    const [showManualLogo, setShowManualLogo] = useState(false);

  const submitProfileBook = (nextLogos = logos) => {
    void handleUpload(
      {
        marketingGoals,
        vibeAndTone,
        targetAudience,
        logos: nextLogos,
        company_name: inputValue || CompanyName || "",
        voice,
        language,
      },
      { configData, getToken }
    );
  };

  const CheckLogo = async (url) => {
    setLoading(true);
    const checkLogoUrl = (url) => {
        return new Promise((resolve) => {
            // 1. Basic URL check
            if (!url || typeof url !== 'string') {
                return resolve(false);
            }

            const img = new Image();
            
            // Use a timeout to handle requests that hang indefinitely
            const timeoutId = setTimeout(() => {
                img.onload = null;
                img.onerror = null;
                resolve(false);
            }, 2000); // 8-second timeout

            // 2. Success Handler
            img.onload = () => {
                clearTimeout(timeoutId);
                // Optional: Check if the image actually has dimensions (not just a 1x1 tracking pixel)
                if (img.naturalWidth > 0) {
                    resolve(true);
                } else {
                    console.warn(`Image loaded but has no dimensions (0x0): ${url}`);
                    resolve(false);
                }
            };
            // 3. Failure Handler
            img.onerror = (error) => {
                clearTimeout(timeoutId);
                resolve(false);
            };
            img.crossOrigin = null;
            img.src = url;
        });
    };
    const isValid = await checkLogoUrl(url);
    if (isValid) {
      const nextLogos = logos.includes(url) ? logos : [url, ...logos];
      setLogos(nextLogos);
      setDefaultLogo('');
      submitProfileBook(nextLogos);
    } else {
      notify("Invalid logo URL. Please provide a valid image URL.", "error");
    }
    setLoading(false);
    return
    }

  useEffect(() => {
    setInputValue(CompanyName);
  }, [CompanyName]);

  useEffect(() => {
    if (logos.length === 0) {
      setlogoUrl("");
      return;
    }
  
    if (!logoUrl || !logos.includes(logoUrl)) {
      setlogoUrl(logos[0]);
    }
  }, [logos, logoUrl, setlogoUrl]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (logoMenuRef.current && !logoMenuRef.current.contains(event.target)) {
        setIsLogoMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <FadeIn className="p-6 md:p-12 flex flex-col h-full">
      {/* Header */}
      <div className="mb-6 shrink-0">
        <h3 className="text-xl font-bold text-blue-900 mb-2 flex items-center gap-2">
          <span className="bg-blue-100 text-blue-800 py-1 px-3 rounded text-sm border border-blue-200">
            Step 1
          </span>
          Campaign Strategy
        </h3>
        <p className="text-blue-700">
          Define the constraints and goals. The AI parses the uploaded Brand Book to ensure compliance.
        </p>
      </div>

      {/* Two-column layout */}
      <div className="flex flex-col lg:flex-row gap-8 flex-1 min-h-0">
        {/* Left Column */}
        <div className="flex-1 flex flex-col gap-6 overflow-y-auto pr-2 custom-scrollbar">
          <h4 className="font-bold text-blue-900 border-b border-blue-100 pb-2">1. Brand Assets</h4>

          {/* Upload Brand Book */}
          <div className="border-2 border-dashed border-blue-300 rounded-lg p-6 text-center hover:bg-blue-50 cursor-pointer transition-colors shrink-0" 
          onClick={() => setShowManualLogo(!showManualLogo)}
          >
            <div className="text-3xl mb-2 flex items-center justify-center">
              {logoUrl ? <img src={logoUrl} alt="Logo" className="w-11 h-11 object-contain" /> : "📕"}
            </div>
            <div className="font-medium text-blue-800">Upload Brand Book</div>
            <div className="text-xs text-blue-500">PDF, JPEG, PNG, SVG (Drag & Drop)</div>
          </div>
          {(logos.length > 0 || showManualLogo) && (
          <div>
            <label className="block text-xs font-bold text-blue-700 uppercase mb-1">Selected Logo</label>
            <div className="flex gap-2">
              <div
                ref={logoMenuRef}
                className="relative flex-1 border border-blue-300 rounded bg-white shadow-sm focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 overflow-visible"
              >
                <input
                  type="text"
                  placeholder="Paste new logo URL"
                  value={DefaultLogo}
                  onChange={(e) => setDefaultLogo(e.target.value)}
                  className="w-full text-sm p-2 pr-16 text-blue-900 focus:outline-none border-0 bg-transparent"
                />
                <button
                  type="button"
                  aria-label="Select existing logo"
                  onClick={() => setIsLogoMenuOpen((prev) => !prev)}
                  className="absolute inset-y-0 right-0 z-20 w-12 border-l border-blue-200 bg-gradient-to-b from-blue-50 to-blue-100 flex items-center justify-center hover:from-blue-100 hover:to-blue-200 focus:outline-none"
                >
                  <ChevronDown
                    size={16}
                    className={`text-blue-700 transition-transform ${isLogoMenuOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isLogoMenuOpen && (
                  <div className="absolute top-full left-0 mt-1 z-30 w-full max-w-full border border-blue-200 rounded bg-white shadow-lg max-h-44 overflow-y-auto overflow-x-hidden">
                    {logos.length === 0 ? (
                      <div className="px-3 py-2 text-sm text-blue-500">No logos yet</div>
                    ) : (
                      logos.map((logo, index) => (
                        <div
                          key={`${logo}-${index}`}
                          className={`flex items-center gap-2 px-2 py-1 min-w-0 ${
                            logoUrl === logo ? "bg-blue-50" : "hover:bg-blue-50"
                          }`}
                        >
                          <button
                            type="button"
                            onClick={() => {
                              setlogoUrl(logo);
                              setIsLogoMenuOpen(false);
                            }}
                            className={`flex-1 min-w-0 text-left px-1 py-1 text-sm ${
                              logoUrl === logo ? "text-blue-900 font-semibold" : "text-blue-800"
                            }`}
                            title={logo}
                          >
                            <span className="block truncate">{logo}</span>
                          </button>
                          <button
                            type="button"
                            aria-label={`Remove logo ${logo}`}
                            title="Remove logo"
                            onClick={(e) => {
                              e.stopPropagation();
                              const nextLogos = logos.filter((item) => item !== logo);
                              setLogos(nextLogos);
                            }}
                            className="shrink-0 p-1 rounded text-blue-500 hover:text-red-500 hover:bg-red-50"
                          >
                            <X size={14} />
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
              <button className="bg-blue-100 text-blue-700 px-3 py-2 rounded text-xs font-bold hover:bg-blue-200 border border-blue-200"
              style={{
                cursor: loading ? "not-allowed" : "pointer",
              }}
              onClick={!loading ? () => {
                CheckLogo(DefaultLogo);
                // console.log(inputValue)
              } : undefined}
              >{loading ? "Loading..." : "Upload"}</button>
            </div>
          </div>
          )}
          {/* Extract from Website */}
          <div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Your Company Name"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onBlur={(e) => setCompanyName(inputValue)}
                className="w-full text-sm border border-blue-300 rounded p-2 text-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Brand Colors */}
          <div>
            <label className="block text-xs font-bold text-blue-700 uppercase mb-1">Manual Brand Colors</label>
            <div className="flex gap-3">
              {brandColors.map((color, i) => (
                <div key={i} className="flex-1">
                  <span className="text-[10px] text-blue-500 font-semibold mb-1 block">
                    {i === 0 ? 'Primary' : i === 1 ? 'Secondary' : 'Accent'}
                  </span>
                  <div className="flex items-center gap-2 border border-blue-300 rounded p-1.5 bg-white">
                    <input
                    type="color"
                    value={color}   // use color directly, not color.value
                    onChange={(e) => {
                        const newColors = [...brandColors];
                        newColors[i] = e.target.value;
                        setBrandColors(newColors);
                    }}
                    className="w-6 h-6 rounded cursor-pointer border-none p-0 bg-transparent"
                    />
                    <span className="text-xs text-blue-900 font-mono">{color}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Language */}
          <div>
            <label className="block text-xs font-bold text-blue-700 uppercase mb-1">Language</label>
            <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="w-full text-sm border border-blue-300 rounded p-2 text-blue-900 bg-white hover:border-blue-500 cursor-pointer focus:outline-none focus:border-blue-500 shadow-sm"
                >
                {languageData.LANGUAGE_LIST.map((lang) => (
                    <option key={lang} value={lang}>
                    {lang}
                    </option>
                ))}
            </select>
          </div>
        </div>
        <Step1PlanRightColumn 
        audioData={audioData}
        setAudio={setAudio}
        bannerData={bannerData}
        setBanner={setBanner}
        CompanyName={CompanyName}
        logoUrl={logoUrl}
        language = {language} 
        marketingGoals = {marketingGoals}
        setMarketingGoals = {setMarketingGoals}
        voice = {voice}
        setVoice = {setVoice}
        targetAudience = {targetAudience}
        setTargetAudience = {setTargetAudience}
        vibeAndTone = {vibeAndTone}
        setVibeAndTone = {setVibeAndTone}
        marketingGoalsDropdown={marketingGoalsDropdown}
        targetAudienceDropdown={targetAudienceDropdown}
        vibeAndToneDropdown={vibeAndToneDropdown}
        voicesDropdown={voicesDropdown}
        brandColors = {brandColors}
        logos = {logos}
        companyName = {inputValue || CompanyName || ""}
        onGenerate = {onGenerate} 
        ></Step1PlanRightColumn>

      </div>
    </FadeIn>
  );
}
